module.exports = __webpack_public_path__ + "static/media/fbLogo.71f3c088.png";